import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from '../../../common/base.component';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { Filter, FlaskFilter } from '../../../models/filter-models';
import { FilterService } from '../../../services/filter.service';
import { ActiveSpecialRules } from '../../../services/filter-generator.service';
import { FlaskFilterComponent } from './flask-filter/flask-filter.component';

@Component({
  selector: 'app-my-flasks-list',
  imports: [FormsModule, FilterTitleComponent, FlaskFilterComponent],
  templateUrl: './my-flasks-list.component.html',
  styleUrl: './my-flasks-list.component.scss'
})
export class MyFlasksListComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  constructor(private filterService: FilterService) {
    super();
  }

  removeFlaskType(index: number) { this.filter.flaskFilters.splice(index, 1); this.updateFilter();  }
  addFlaskType = () => { this.filter.flaskFilters.push(new FlaskFilter()); this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
